module.exports = __webpack_public_path__ + "static/media/dk.eb1416e0.svg";